<template>
  <div class="flex items-center justify-center gap-2 py-4">
    <template v-for="n in total">
      <div
        :key="n"
        class="h-1.5 rounded-full transition-all duration-200"
        :class="n <= current ? 'bg-black w-8' : 'bg-gray-200 w-8 opacity-60'"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "WizardSteps",
  props: {
    current: { type: Number, required: true },
    total: { type: Number, required: true }
  }
}
</script>
